import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const chargebee = defineConnector({
  identifier: "chargebee",
  name: "Chargebee",
  tagLine: "Subscription billing platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://.+\\.chargebee\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.secret.apiKey,
      password: "",
    }),
  steps: [
    {
      title: "Enter your Chargebee domain name",
      items: [
        {
          kind: "hostname",
          label: "Site name",
          required: true,
          target: { kind: "configuration", field: "domain" },
          helperText:
            "Your Chargebee subdomain (e.g., 'mycompany' from mycompany.chargebee.com).",
        },
      ],
    },
    {
      title: "Get your Chargebee API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Chargebee, go to **Settings > Configure Chargebee > API Keys** and create a new API key or use an existing one.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/v2/subscriptions`,
  },
  publicEnvVars: ({ domain }) => ({
    CHARGEBEE_URL: domain ? `https://${domain}` : "",
  }),
});
